import fetch from '@/utils/fetch';

export function buldingCreate(query) {   // 基本信息保存
    return fetch({
        url: '/Cykj/Cykj/saveIndustrialSpace',
        method: 'post',
        data: query
    });
}

export function floorCreate(query) {   // 附加列表保存
    return fetch({
        url: '/Cykj/Cykj/batchSaveIndustrialSpaceFloor',
        method: 'post',
        data: query
    });
}

export function getBuildings(query) {   // 获取楼宇列表
    return fetch({
        url: '/Cykj/Cykj/getIndustrialSpaceWhereByFileds',
        method: 'post',
        data: query
    });
}

export function removeBuilding(query) {   //  删除楼宇
    return fetch({
        url: '/Cykj/Cykj/deleteIndustrialSpace',
        method: 'post',
        data: query
    });
}

export function getFloors(query) {   // 获取楼层列表
    return fetch({
        url: '/Cykj/Cykj/getIndustrialSpaceFloorWhereByFileds',
        method: 'post',
        data: query
    });
}

export function upState(query) {   // 状态更新
    return fetch({
        url: '/Cykj/Cykj/batchUpdateIndustrialSpaceStatus',
        method: 'post',
        data: query
    });
}

export function getBuildingInfos(query) {   // 获取详情
    return fetch({
        url: '/Cykj/Cykj/getIndustrialSpaceById',
        method: 'post',
        data: query
    });
}

export function getUserList(query) {   // 查询用户
    return fetch({
        url: '/User/User/getUserListByWhere',
        method: 'post',
        data: query
    });
}

export function getRecord(query) {   // 审核历史
    return fetch({
        url: '/Cykj/Cykj/queryIndustrialSpaceHistoryRecordListByIndustrialSpaceId',
        method: 'post',
        data: query
    });
}

export function getRecordInfos(query) {   // 历史版本
    return fetch({
        url: '/Cykj/Cykj/getIndustrialSpaceSnapshotById',
        method: 'post',
        data: query
    });
}

export function importIndustrialSpaces(query) {   // 历史版本
    return fetch({
        url: '/Cykj/Cykj/importIndustrialSpaces',
        method: 'post',
        data: query
    });
}
export function getErrorImportLog(query) {   // 历史版本
    return fetch({
        url: '/Cykj/Cykj/getErrorImportLog',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/industryInfos/index.js